import { unhandledRequest } from 'api/request';

import {
  JourneyListEnvelope,
  JourneyListRow,
  SaveJourneyConfigResponse,
} from '../components/types';
import { JourneyAttribute, StoredFieldConfig } from '../field-config/types';

export type ManageJourneyType = JourneyListRow;

export type ManageJourneysResponse = JourneyListEnvelope<ManageJourneyType>;

export async function getManageJourneys(search: string): Promise<ManageJourneysResponse> {
  const response = await unhandledRequest.get<ManageJourneysResponse>({
    url: `/integrations/journeys/manage/journeys/`,
    params: { search },
  });
  return response.data;
}

export type SetJourneyEnabledInput = {
  journeyId: string;
  isEnabled: boolean;
};

export type SetJourneyEnabledResponse = {
  journeyId: string;
  isEnabled: boolean;
};

export async function setJourneyEnabled(
  input: SetJourneyEnabledInput,
): Promise<SetJourneyEnabledResponse> {
  const response = await unhandledRequest.put<SetJourneyEnabledResponse>({
    url: `/integrations/journeys/manage/journeys/${input.journeyId}/enabled/`,
    data: { isEnabled: input.isEnabled },
  });
  return response.data;
}

// ---- Global field config API ----

export type JourneyConfigResponse = {
  attributes: JourneyAttribute[];
  // A never-configured journey comes back as `{}` (no base/fields) — Partial so
  // the type matches what the backend actually returns. buildDraftFromFieldConfig
  // defends each key.
  field_config: Partial<StoredFieldConfig>;
};

export async function getJourneyConfig(journeyId: string): Promise<JourneyConfigResponse> {
  const response = await unhandledRequest.get<JourneyConfigResponse>({
    url: `/integrations/journeys/manage/journeys/${journeyId}/config/`,
  });
  return response.data;
}

export type SaveJourneyConfigInput = {
  journeyId: string;
  fieldConfig: StoredFieldConfig;
};

export type { SaveJourneyConfigResponse };

export async function saveJourneyConfig(
  input: SaveJourneyConfigInput,
): Promise<SaveJourneyConfigResponse> {
  const response = await unhandledRequest.put<SaveJourneyConfigResponse>({
    url: `/integrations/journeys/manage/journeys/${input.journeyId}/config/`,
    data: { field_config: input.fieldConfig },
  });
  return response.data;
}
